import React from 'react';

const markup = String.raw`<div class="card" id="vendActionCard">
<div class="card-head"><p class="card-title">Action Center</p><span class="card-tag" id="vendActionCount">4 items</span></div>
<div class="alert-list" id="vendActionList"></div>
</div>`;

export default function ActionCenterCard() {
  return <div className="raw-fragment" dangerouslySetInnerHTML={{ __html: markup }} />;
}
